"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SERVER_ERROR = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _SessionHandler = _interopRequireWildcard(require("./SessionHandler"));
var _mainConfig = _interopRequireDefault(require("../mainConfig"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SERVER_ERROR = exports.SERVER_ERROR = 'serverError';
var GlobalErrorHandler = /*#__PURE__*/function () {
  function GlobalErrorHandler() {
    (0, _classCallCheck2.default)(this, GlobalErrorHandler);
    (0, _defineProperty2.default)(this, "errorMsgs", void 0);
    (0, _defineProperty2.default)(this, "errorPage500Path", void 0);
    (0, _defineProperty2.default)(this, "redirectOn500", void 0);
    (0, _defineProperty2.default)(this, "representativeInfoPage", void 0);
    this.errorMsgs = {};
    this.errorPage500Path = null;
    this.redirectOn500 = false;
    this.representativeInfoPage = null;
  }
  (0, _createClass2.default)(GlobalErrorHandler, null, [{
    key: "getErrorMessage",
    value: function getErrorMessage(name) {
      return this.errorMsgs && this.errorMsgs[name] ? this.errorMsgs[name] : '';
    }
  }, {
    key: "addGlobalErrorMsgs",
    value: function addGlobalErrorMsgs(msgs) {
      this.errorMsgs = _objectSpread(_objectSpread({}, this.errorMsgs), msgs);
    }
  }, {
    key: "handleException",
    value: function handleException(exception) {
      var _CONFIG$AEM_CONFIG, _CONFIG$AEM_CONFIG2;
      var handleRedirect = function handleRedirect() {
        if (!exception.toRedirect) {
          return;
        }
        sessionStorage.cscRedirectLock = 1;
        _SessionHandler.default.destroyLocalSession();
        if ([_SessionHandler.loginTypes.loggedIn, _SessionHandler.loginTypes.callCenter].includes(exception.loginType)) {
          _SessionHandler.default.destroyRemoteSso(true, _SessionHandler.default.getRedirectUrl(exception.loginType));
        } else {
          location.replace(_SessionHandler.default.getRedirectUrl(exception.loginType));
        }
      };
      var pageName = window && window.location && window.location.pathname ? window.location.pathname.split('/').pop() : '';
      var itIsOopsPage = this.errorPage500Path && (pageName === null || pageName === void 0 ? void 0 : pageName.length) && this.errorPage500Path.indexOf(pageName) !== -1;
      if (exception.name === 'FunkeUnauthenticated' && !_mainConfig.default.AEM_CONFIG.isAuthorMode && !(_mainConfig.default === null || _mainConfig.default === void 0 ? void 0 : (_CONFIG$AEM_CONFIG = _mainConfig.default.AEM_CONFIG) === null || _CONFIG$AEM_CONFIG === void 0 ? void 0 : _CONFIG$AEM_CONFIG.isA11yModeEnabled)) {
        handleRedirect();
      } else if (exception.name === 'FunkeUnauthorized' && !_mainConfig.default.AEM_CONFIG.isAuthorMode && !(_mainConfig.default === null || _mainConfig.default === void 0 ? void 0 : (_CONFIG$AEM_CONFIG2 = _mainConfig.default.AEM_CONFIG) === null || _CONFIG$AEM_CONFIG2 === void 0 ? void 0 : _CONFIG$AEM_CONFIG2.isA11yModeEnabled)) {
        handleRedirect();
      } else if (exception.name === 'FunkeResourseNotAvailabe') {
        // not implemented right now
        // const resources = RestHelper.getRootResources();
        // if (resources.meterreadingauth && !CONFIG.AEM_CONFIG.isAuthorMode) {
        //   handleRedirect();
        // }
      } else if (exception.name === 'Funke500ServerError' && this.redirectOn500 && !itIsOopsPage && !sessionStorage.cscRedirectLock) {
        location.replace(this.errorPage500Path);
      } else if (exception.name === 'MyNetworkError' && !itIsOopsPage && this.redirectOn500 && !sessionStorage.cscRedirectLock) {
        location.replace(this.errorPage500Path);
      } else if (exception.name === 'NoImplementation' && !itIsOopsPage && !sessionStorage.cscRedirectLock) {
        sessionStorage.cscRedirectLock = 1;
        location.replace(this.representativeInfoPage);
      }
    }
  }]);
  return GlobalErrorHandler;
}();
(0, _defineProperty2.default)(GlobalErrorHandler, "errorMsgs", void 0);
(0, _defineProperty2.default)(GlobalErrorHandler, "errorPage500Path", void 0);
(0, _defineProperty2.default)(GlobalErrorHandler, "redirectOn500", void 0);
(0, _defineProperty2.default)(GlobalErrorHandler, "representativeInfoPage", void 0);
var _default = exports.default = GlobalErrorHandler;